import React, { useState, useRef, useEffect } from 'react';
import {
  Box,
  Card,
  CardContent,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  Button,
  Typography,
  Grid,
  Divider,
  Avatar,
  Checkbox,
  Paper,
  Container,
  Stepper,
  Step,
  StepLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormHelperText,
  Chip,
  LinearProgress,
  Fade,
  Slide,
  IconButton,
  OutlinedInput,
  InputAdornment ,
  Autocomplete
} from '@mui/material';
import {
  CloudUpload,
  Home,
  Search,
  Save,
  CreditCard,
  Clear,
  CameraAlt,
  Person,
  LocalHospital,
  ContactPhone,
  NavigateNext,
  NavigateBefore,
  CheckCircle,
  Close,
  PhotoCamera,
  Upload,
  Thermostat,
  Favorite,
  MonitorHeart,
  Air,
} from '@mui/icons-material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import AddTaskIcon from '@mui/icons-material/AddTask';
import dayjs from 'dayjs';
import axios from 'axios';
import { loadInsurance, loadPatientsClaToday, loadpolicy, loadStayAt, SavePatientInformation, uploadPatient ,URL, savePatienVitals } from '../../BaseURL';
import Swal from 'sweetalert2';
import Ccc from '../../Record/Ccc';
import { successMessage ,sms_Welcome } from '../../Message';
import moment from 'moment'
import PatientVitals  from './PatientVitals';
import BedAssignmentDialog from './BedAssignmentDialog';

// Custom theme with beautiful colors
const theme = createTheme({
  palette: {
    primary: {
      main: '#10b981',
      light: '#10b981',
      dark: '#10b981',
    },
    secondary: {
      main: '#10b981',
      light: '#34d399',
      dark: '#059669',
    },
    error: {
      main: '#ef4444',
      light: '#f87171',
      dark: '#dc2626',
    },
    warning: {
      main: '#f59e0b',
      light: '#fbbf24',
      dark: '#d97706',
    },
    info: {
      main: '#8b5cf6',
      light: '#a78bfa',
      dark: '#7c3aed',
    },
    background: {
      default: '#f8fafc',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h4: {
      fontWeight: 700,
      fontSize: '2rem',
    },
    h6: {
      fontWeight: 600,
      fontSize: '1.25rem',
    },
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
        },
      },
    },
  },
});

// Helper function to safely create dayjs date
const safeDayjs = (date) => {
  if (!date) return null;
  
  try {
    const dayjsDate = dayjs(date);
    return dayjsDate.isValid() ? dayjsDate : null;
  } catch (error) {
    console.warn('Invalid date provided to safeDayjs:', date);
    return null;
  }
};

const PatientInformation = ({ selectedPatient, onPatientSaved }) => {
  const [activeStep, setActiveStep] = useState(0);
  const [cameraOpen, setCameraOpen] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [imagePath, setImagePath] = useState('');
  const [loading, setLoading] = useState(false);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const fileInputRef = useRef(null);
  const streamRef = useRef(null);
  const [vitalsInfo, setVitalsInfo] = useState(null);
  const [bedDialogOpen, setBedDialogOpen]   = useState(false);
  const [bedDialogPatient, setBedDialogPatient] = useState(null);

  // ER intake vitals captured inline as the final wizard step.
  // Temperature is required; other fields are optional first-pass.
  const [vitalsForm, setVitalsForm] = useState({
    temperature: '',
    pulse: '',
    bloodPressure: '',
    respirationRate: '',
    spo2: '',
  });
  const handleVitalChange = (field) => (event) => {
    if (errors[`vital_${field}`]) {
      setErrors(prev => ({ ...prev, [`vital_${field}`]: '' }));
    }
    setVitalsForm(prev => ({ ...prev, [field]: event.target.value }));
  };

  const erUserInfo = (() => {
    try { return JSON.parse(localStorage.getItem('userInfo') || '{}'); } catch { return {}; }
  })();

  let Todaydate = moment().format('YYYY-MM-DD')

  const [formData, setFormData] = useState({
    patientId: '',
    surname: '',
    othername: '',
    gender: '',
    dateOfBirth: null,
    stayAt: '',
    educationalLevel: '',
    occupation: '',
    religion: '',
    insuranceStatus: '',
    ccc: '',
    cardType: '',
    membershipNo: '',
    ghanaCardNo: '',
    policyOption: '',
    boxNumber: '',
    telNumber: '',
    emailAddress: '',
    maritalStatus: '',
    spouseName: '',
    numberOfChildren: '',
    accompaniedByName: '',
    accompaniedByTel: '',
    relation: '',
    dependant: 0,
    duaInsurance: 0,
    trans_code: '',
    user: '',
    imagePath: ''
  });

  const [isEditMode, setIsEditMode] = useState(false);
  const [openCCC, setopenCCC] = useState(false);
  const [inss, setins] = useState();
  const [errors, setErrors] = useState({});
  const [cardTypeOptions, setcardTypeOptions] = useState([]);
  const [policyOptions, setpolicyOptions] = useState([]);
  const [openPatient, setopenPatient] = useState(false);
 
  // Main image saving function
  const saveImageToFolder = async (imageDataUrl, patientId) => {
    try {
      // Convert data URL to blob
      const response = await fetch(imageDataUrl);
      const blob = await response.blob();
      
      // Create FormData
      const formDataForUpload = new FormData();
      const fileName = `patient_${patientId}_${Date.now()}.jpg`;
      formDataForUpload.append('image', blob, fileName);
      formDataForUpload.append('patientId', patientId);
      formDataForUpload.append('fileName', fileName);
      
      // Send to your backend endpoint for image upload
      const uploadResponse = await axios.post(uploadPatient, formDataForUpload, {
        headers: { 
          'Content-Type': 'multipart/form-data' 
        },
        timeout: 10000 // 10 second timeout
      });
      
      if (uploadResponse.data.success) {
        const serverImagePath = uploadResponse.data.imagePath;
        setImagePath(serverImagePath);
        
        // Update form data with image path
        setFormData(prevFormData => ({
          ...prevFormData,
          imagePath: serverImagePath
        }));
        
        // Clear any temporary storage
        localStorage.removeItem(`temp_patient_image_${patientId}`);
        
        return serverImagePath;
      } else {
        throw new Error(uploadResponse.data.message || 'Failed to upload image');
      }
      
    } catch (error) {
      console.error('Error saving image to server:', error);
      
    }
  };

    // Function to load existing image from server
  const loadImageFromPath = async (imagePath) => {
    if (!imagePath) return;
    
    try {
      // If imagePath is already a full URL, use it directly
      if (imagePath.startsWith('http') || imagePath.startsWith('data:')) {
        setImagePreview(imagePath);
        return;
      }
      
      // If it's a relative path, construct the full URL
      // Adjust this base URL to match your server configuration
      const baseURL = URL; // Replace with your actual server URL
      const fullImageURL = `${baseURL}/${imagePath}`;
      
      // Test if the image exists by trying to load it
      const img = new Image();
      img.onload = () => {
        setImagePreview(fullImageURL);
      };
      img.onerror = () => {
        console.warn(`Image not found at path: ${fullImageURL}`);
        // You might want to set a default placeholder image here
        setImagePreview(null);
      };
      img.src = fullImageURL;
      
    } catch (error) {
      console.error('Error loading image:', error);
      setImagePreview(null);
    }
  };

  // ============= IMAGE HANDLING FUNCTIONS =============

 const handleImageUpload = async (event) => {
  const file = event.target.files[0];
  if (file) {
    // Validate file size (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      Swal.fire({
        title: 'File Too Large',
        text: 'Please select an image smaller than 5MB',
        icon: 'warning'
      });
      return;
    }
    
    // Validate file type
    if (!file.type.startsWith('image/')) {
      Swal.fire({
        title: 'Invalid File Type',
        text: 'Please select an image file',
        icon: 'warning'
      });
      return;
    }
    
    // Show loading
    Swal.fire({
      title: 'Uploading Image...',
      text: 'Please wait while we upload your image',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    
    const reader = new FileReader();
    reader.onload = async (e) => {
      setImagePreview(e.target.result);
      
      // Save image to server
      const patientId = formData.patientId || formData.surname || `temp_${Date.now()}`;
      const path = await saveImageToFolder(e.target.result, patientId);
      
      Swal.close(); // Close loading dialog
      
      if (path) {
        console.log('Image uploaded and saved to:', path);
      }
    };
    reader.readAsDataURL(file);
  }
};
  const openCamera = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ 
        video: { 
          width: { ideal: 640 },
          height: { ideal: 480 },
          aspectRatio: 4/3,
          facingMode: 'user'
        } 
      });
      streamRef.current = stream;
      setCameraOpen(true);
      
      setTimeout(() => {
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          videoRef.current.addEventListener('loadedmetadata', () => {
            videoRef.current.play();
          });
        }
      }, 100);
    } catch (error) {
      console.error('Error accessing camera:', error);
      Swal.fire({
        title: 'Camera Error',
        text: 'Unable to access camera. Please check permissions.',
        icon: 'error'
      });
    }
  };

  const capturePhoto = async () => {
  if (videoRef.current && canvasRef.current) {
    const canvas = canvasRef.current;
    const video = videoRef.current;
    const context = canvas.getContext('2d');
    
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.drawImage(video, 0, 0, canvas.width, canvas.height);
    
    const imageDataUrl = canvas.toDataURL('image/jpeg', 0.8);
    setImagePreview(imageDataUrl);
    
    
    
    closeCamera();
  }
};

  const closeCamera = () => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach(track => track.stop());
      streamRef.current = null;
    }
    setCameraOpen(false);
  };

  // ============= OTHER COMPONENT FUNCTIONS =============

  const handelopenCCC = () => {
    setopenCCC(true);
  };

  const handelCloseCCC = () => {
    setopenCCC(false);
  };

  const handelClosePatient = () => {
     setVitalsInfo(null)
    setopenPatient(false);
  };


  const steps = [
    { 
      label: 'Insurance Information', 
      icon: <LocalHospital />, 
      color: '#10b981',
      description: 'Insurance and policy details'
    },
    { 
      label: 'Basic Information', 
      icon: <Person />, 
      color: '#10b981',
      description: 'Personal details and family info'
    },
    {
      label: 'Contact & Other Info',
      icon: <ContactPhone />,
      color: '#10b981',
      description: 'Contact details and accompaniment'
    },
    {
      label: 'Vitals',
      icon: <Thermostat />,
      color: '#10b981',
      description: 'Initial vitals (temperature required)'
    }
  ];

  useEffect(() => {
    const savedUserInfo = localStorage.getItem('userInfo');
    if (savedUserInfo) {
      const userInfo = JSON.parse(savedUserInfo);
      const userName = userInfo.name || '';
      
      setFormData(prevFormData => ({
        ...prevFormData,
        user: userName
      }));
      
      //console.log('User loaded from localStorage:', userName);
    } else {
     // console.log('No userInfo found in localStorage');
    }
  }, []);

 // Load patient data when selectedPatient changes - FIXED DATE HANDLING
  useEffect(() => {
    if (selectedPatient) {
      const savedUserInfo = localStorage.getItem('userInfo');
      const currentUser = savedUserInfo ? JSON.parse(savedUserInfo).name : '';
      
      const patientImagePath = selectedPatient.imagePath || '';
      
      setFormData({
        trans_code: selectedPatient.trans_code || '',
        patientId: selectedPatient.id || '',
        surname: selectedPatient.surname || '',
        othername: selectedPatient.name || '',
        gender: selectedPatient.gender || '',
        dateOfBirth: safeDayjs(selectedPatient.dob), // FIXED: Use safeDayjs helper
        stayAt: selectedPatient.res || '',
        maritalStatus: selectedPatient.ma_stu || '',
        spouseName: selectedPatient.name_spo || '',
        numberOfChildren: selectedPatient.no_child || '',
        educationalLevel: selectedPatient.eud || '',
        occupation: selectedPatient.occ || '',
        religion: selectedPatient.Religion || '',
        boxNumber: selectedPatient.bok || '',
        telNumber: selectedPatient.tel || '',
        emailAddress: selectedPatient.ema || '',
        accompaniedByName: selectedPatient.a_name || '',
        accompaniedByTel: selectedPatient.a_tel || '',
        relation: selectedPatient.a_rel || '',
        membershipNo: selectedPatient.Insurance || '',
        cardType: selectedPatient.type || '',
        ghanaCardNo: selectedPatient.gh_card || '',
        policyOption: selectedPatient.type || '',
        imagePath: patientImagePath,
        user: currentUser,
       dependant: selectedPatient.Dependant || 0,
      });
      
      // Load the existing image
      setImagePath(patientImagePath);
      if (patientImagePath) {
        loadImageFromPath(patientImagePath);
      } else {
        setImagePreview(null);
      }
      
      setIsEditMode(true);
    } else {
      const savedUserInfo = localStorage.getItem('userInfo');
      const currentUser = savedUserInfo ? JSON.parse(savedUserInfo).name : '';

      setFormData({
        patientId: '',
        surname: '',
        othername: '',
        gender: '',
        dateOfBirth: null, 
        stayAt: '',
        educationalLevel: '',
        occupation: '',
        religion: '',
        insuranceStatus: '',
        ccc: '',
        cardType: '',
        membershipNo: '',
        ghanaCardNo: '',
        policyOption: '',
        boxNumber: '',
        telNumber: '',
        emailAddress: '',
        maritalStatus: '',
        spouseName: '',
        numberOfChildren: '',
        accompaniedByName: '',
        accompaniedByTel: '',
        relation: '',
        dependant: 0,
        duaInsurance: false,
        trans_code: '',
        user: currentUser,
        imagePath: ''
      });
      setIsEditMode(false);
      setImagePreview(null);
      setImagePath('');
    }
  }, [selectedPatient]);



 const getCCCData = (getCCCData) => {
  if (getCCCData.MobCCC) {
    // CCC was generated successfully - populate all fields with CCC data
    let firstname = '';
    let otherNames = '';
    
    const nameParts = getCCCData.MemberName.trim().split(' ').map(part => part.trim());

    if (nameParts.length === 1) {
      firstname = nameParts[0];
    } else {
      otherNames = nameParts[0];
      firstname = nameParts.slice(1).join(' ');
    }

    setFormData(prevFormData => ({
      ...prevFormData, 
      ccc: getCCCData.MobCCC, 
      membershipNo: getCCCData.HIN,
      surname: firstname,
      othername: otherNames, 
      gender: getCCCData.Gender,
      dateOfBirth: safeDayjs(getCCCData.DateOfBirth),
    }));

    
  } else {
    
    setFormData(prevFormData => ({
      ...prevFormData, 
      ccc: '' 
    }));
    
    
   
  }
  
  // Clear CCC validation error if it exists
  if (errors.ccc) {
    setErrors(prev => ({ ...prev, ccc: '' }));
  }
};



  // The rest of your existing validation, input handling, and rendering functions remain the same...
  // [Include all your existing functions: validateStep, handleInputChange, handleNext, handleBack, etc.]

  const validateStep = (step) => {
    const newErrors = {};
    
    if (step === 0) {
      if (!formData.cardType) newErrors.cardType = 'Card Type is required';

      const getselectedins = cardTypeOptions.find(obj => obj.name == formData.cardType);

      if (getselectedins?.ccc === 'Required') {
        const membershipNoValue = formData.membershipNo?.toString() || '';
        
        if (!membershipNoValue.trim()) {
          newErrors.membershipNo = 'Membership Number is required';
        }
      }
      

      if (formData.membershipNo=='' &&  formData.cardType !='Non Insured') {
          newErrors.membershipNo = 'Membership Number is required';
        }

      /*  Same rule as Record/PatientInformation.js — see the longer note there.
       *  In short: no insurance row in this database holds the string
       *  'Required', because the admin screen writes '1'/'0', so this test never
       *  fired for any scheme. And a blank `cccc` means "no fixed length", not
       *  "zero characters". The server enforces the same rule in
       *  /SavePatientInformation, which is the half that actually holds. */
      const REQUIRED_WORDS = ['required', 'yes', 'true', '1', 'y', 'on', 'compulsory'];
      const cccIsRequired = getselectedins != null && (
        getselectedins.ccc === true || getselectedins.ccc === 1
        || REQUIRED_WORDS.includes(String(getselectedins.ccc ?? '').trim().toLowerCase())
      );

      if (cccIsRequired) {
        const cccValue = (formData.ccc ?? '').toString().trim();
        const wantLen = Number(String(getselectedins.cccc ?? '').trim());
        const hasLen = Number.isInteger(wantLen) && wantLen > 0;

        if (!cccValue || cccValue === '-' || /^0+$/.test(cccValue)) {
          newErrors.ccc = `${getselectedins.name || 'This insurance'} requires a CCC`;
        } else if (hasLen && cccValue.length !== wantLen) {
          newErrors.ccc = `CCC must be ${wantLen} characters — this one is ${cccValue.length}`;
        }
      }

    } else if (step === 1) {
      if (!formData.surname?.trim()) newErrors.surname = 'Surname is required';
      if (!formData.othername?.trim()) newErrors.othername = 'Other name is required';
      if (!formData.gender) newErrors.gender = 'Gender is required';
      if (!formData.dateOfBirth) newErrors.dateOfBirth = 'Date of Birth is required';
      if (!formData.stayAt?.trim()) newErrors.stayAt = 'Stay At address is required';
      if (!formData.maritalStatus) newErrors.maritalStatus = 'Marital Status is required';
      
    } else if (step === 2) {
      if (!formData.telNumber?.trim()) {
        newErrors.telNumber = 'Telephone Number is required';
      } else {
        // Remove any non-digit characters for validation
        const cleanedNumber = formData.telNumber.replace(/\D/g, '');
        if (cleanedNumber.length !== 10) {
          newErrors.telNumber = 'Telephone Number must be exactly 10 digits';
        }
      }
    } else if (step === 3) {
      // Vitals step — temperature is the minimum ER requirement
      const temp = vitalsForm.temperature?.toString().trim();
      if (!temp) {
        newErrors.vital_temperature = 'Temperature is required';
      } else {
        const t = parseFloat(temp);
        if (Number.isNaN(t) || t < 25 || t > 45) {
          newErrors.vital_temperature = 'Enter a valid temperature (25–45 °C)';
        }
      }
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (field) => (event) => {
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }
    
    let value = event.target.value;
    
    if (field === 'ccc') {
      value = value.toString().trim();
    } else if (field === 'telNumber') {
      // Allow only digits and common phone number separators, limit to reasonable length
      value = value.replace(/[^\d\s\-\+\(\)]/g, '');
      if (value.length > 15) { // Reasonable limit including separators
        value = value.slice(0, 15);
      }
    }
    
    setFormData(prevFormData => ({
      ...prevFormData,
      [field]: value
    }));
  };

  const handleCheckboxChange = (field) => (event) => {
    setFormData({
      ...formData,
      [field]: event.target.checked
    });
  };

  const handleDateChange = (date) => {
    if (errors.dateOfBirth) {
      setErrors(prev => ({ ...prev, dateOfBirth: '' }));
    }
    
    // FIXED: Ensure we're setting a valid dayjs object or null
    const validDate = date && dayjs(date).isValid() ? dayjs(date) : null;
    
    setFormData({
      ...formData,
      dateOfBirth: validDate
    });
  };

  const handleNext = () => {
    if (validateStep(activeStep)) {
      setLoading(true);
      setTimeout(() => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setLoading(false);
      }, 500);
    }
  };

  const handleBack = () => {
    setErrors({});
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    const savedUserInfo = localStorage.getItem('userInfo');
    const currentUser = savedUserInfo ? JSON.parse(savedUserInfo).name : '';
    setActiveStep(0);
    setFormData({
      patientId: '',
      surname: '',
      othername: '',
      gender: '',
      dateOfBirth: null,
      stayAt: '',
      educationalLevel: '',
      occupation: '',
      religion: '',
      insuranceStatus: '',
      ccc: '',
      cardType: '',
      membershipNo: '',
      ghanaCardNo: '',
      policyOption: '',
      boxNumber: '',
      telNumber: '',
      emailAddress: '',
      maritalStatus: '',
      spouseName: '',
      numberOfChildren: '',
      accompaniedByName: '',
      accompaniedByTel: '',
      relation: '',
      dependant: 0,
      duaInsurance: false,
      trans_code: '',
      user: currentUser,
      imagePath: ''
    });
    setErrors({});
    setImagePreview(null);
    setImagePath('');
    setVitalsForm({
      temperature: '',
      pulse: '',
      bloodPressure: '',
      respirationRate: '',
      spo2: '',
    });
  };

  const educationOptions = ['No Education', 'Basic', 'J.H.S', 'SHS', 'Tertiary', 'Others'];
  const religionOptions = ['Christian', 'Muslim', 'Traditional', 'Other'];
  const maritalStatusOptions = ['SINGLE', 'MARRIED', 'WIDOWED', 'DIVORCED'];
  const relationOptions = ['Father', 'Mother', 'Child', 'Wife', 'Husband', 'Uncle', 'Grandmother', 'Grandfather', 'Brother', 'Sister', 'Others'];


  const [stayAtOptions ,setstayAtOptions] = useState([]);

  useEffect(() => {
     loadIns();
     loadStay();
    if (selectedPatient) {
      loadInsPolicy(selectedPatient.type);
      loadInscla();
     
    }
  }, []);

  useEffect(() => {
    if (inss && inss.length > 0 && inss[0]?.ccc) {
      setFormData(prevFormData => ({ 
        ...prevFormData, 
        ccc: inss[0].ccc.toString().trim() ,dependant:inss[0].Dependant
      }));
      
      if (errors.ccc) {
        setErrors(prev => ({ ...prev, ccc: '' }));
      }
    }
  }, [inss]);

  useEffect(() => {
    loadInsPolicy(formData.cardType);
  }, [formData.cardType]);
  
  const loadIns = async () => {
    try {   

      const response = await axios.get(loadInsurance);
      if (response.data.success) {
        setcardTypeOptions(response.data.results); 
        console.log(response.data.results);
      }
    } catch (error) {
      await Swal.fire({
        title: 'Error',
        text: error.response?.data?.message || 'Failed to Load Insurance Companies',
        icon: 'error'
      });
    }
  };
  
  const loadInsPolicy = async (type) => {
    try {
      const response = await axios.get(loadpolicy);
      if (response.data.success) {
        console.log(response.data.results);
        const filterINPO = response.data.results.filter(obj => obj.insurance == type);
        setpolicyOptions(filterINPO);
      }
    } catch (error) {
      await Swal.fire({
        title: 'Error',
        text: error.response?.data?.message || 'Failed to Load Insurance Companies',
        icon: 'error'
      });
    }
  };

  const loadInscla = async () => {
    try {
      const patientId = selectedPatient.id;
      const dat = Todaydate;
      const response = await axios.post(loadPatientsClaToday, { patientId, dat });
      
      if (response.data.success) {
        console.log('API Response:', response.data.results);
        setins(response.data.results);
      }
    } catch (error) {
      console.error('Error loading insurance claim:', error);
      await Swal.fire({
        title: 'Error',
        text: error.response?.data?.message || 'Failed to Load Insurance Claim',
        icon: 'error'
      });
    }
  };


  const loadStay = async () => {
    try {
      
      const response = await axios.get(loadStayAt);
      
      if (response.data.success) {
        
        setstayAtOptions(response.data.results);
      }
    } catch (error) {
      console.error('Error loading insurance claim:', error);
      await Swal.fire({
        title: 'Error',
        text: error.response?.data?.message || 'Failed to Load Insurance Claim',
        icon: 'error'
      });
    }
  };


  

  const handleSubmit = async () => {
  if (validateStep(activeStep)) {
    const result = await Swal.fire({
      title: 'Confirm / Cancel',
      text: "Are You Sure You Want To Save Patient Information ?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes Confirm'
    });

    if (result.isConfirmed) {
      Swal.fire({
        title: 'Processing.......',
        text: 'Please wait',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      try {
        let finalImagePath = imagePath || formData.imagePath;
        
        // If there's an image preview but no saved path yet, upload it first
        if (imagePreview && !finalImagePath) {
          const patientId = formData.patientId || formData.surname || `temp_${Date.now()}`;
          finalImagePath = await saveImageToFolder(imagePreview, patientId);
        }

        const dataToSave = {
          ...formData,
          imagePath: finalImagePath || ''
        };

        //console.log('Saving patient data with image path:', finalImagePath);

        const response = await axios.post(SavePatientInformation, dataToSave);

        if (response.data.success) {

         // successMessage('Save', response.data.message);
        // Swal.fire('Patient ID : '+response.data.PatientInfo.id);

       if (response.data.todayStatus === 'FIRST_TODAY') {
          // facilityName omitted — backend fills it from the assembly row.
          sms_Welcome(
            formData.telNumber,
            `${formData.surname} ${formData.othername}`,
            response.data.PatientInfo.id
          );
        }

        // Persist the inline vitals captured in step 4. Failures here are
        // logged but don't block bed assignment — the user can re-enter them
        // from the Vitals tab afterwards.
        try {
          const info = response.data.PatientInfo;
          await axios.post(savePatienVitals, {
            field1: info.id,
            field2: info.name || `${formData.surname} ${formData.othername}`.trim(),
            field3: info.gender || formData.gender,
            field4: info.age,
            time: moment().format('HH:mm'),
            date: moment().format('YYYY-MM-DD'),
            temperature:     vitalsForm.temperature,
            pulse:           vitalsForm.pulse,
            bloodPressure:   vitalsForm.bloodPressure,
            respirationRate: vitalsForm.respirationRate,
            spo2:            vitalsForm.spo2,
            weight: '', height: '', bmi: '', fbs: '', rbs: '',
            temperatureRemarks: '', pulseRemarks: '',
            bloodPressureRemarks: '', respirationRateRemarks: '',
            bmiRemarks: '', fbsRemarks: '', rbsRemarks: '',
          });
        } catch (vErr) {
          console.error('Vitals save failed (non-blocking):', vErr);
        }

          handleReset()

        // Dismiss the "Processing…" SweetAlert before opening the bed dialog,
        // otherwise it stays mounted on top and blocks interaction.
        Swal.close();

        // ER flow: bed assignment is mandatory — open the dialog directly,
        // no "Do you want…" prompt. Vitals are chained on success.
        setBedDialogPatient(response.data.PatientInfo);
        setBedDialogOpen(true);

          
      
        }
      } catch (error) {
        const data = error.response?.data;

        /*  ALREADY REGISTERED — the same refusal the Medical Records form
         *  handles, because both screens post to /SavePatientInformation and the
         *  server refuses a duplicate on either. Without this the emergency room
         *  would see only "Failed to Save Patient Information", which reads as a
         *  system fault at the worst possible moment.
         *
         *  Shorter wording than the Records version on purpose: an ER registrar
         *  needs the folder number and the next step, not the reasoning. */
        if (data?.code === 'DUPLICATE_PATIENT') {
          const p = data.existing || {};
          await Swal.fire({
            icon: 'warning',
            title: 'This patient is already registered',
            html: `
              <div style="text-align:left;font-size:13.5px;line-height:1.65">
                <div style="background:#f8fafc;border:1px solid #e2e8f0;
                            border-radius:8px;padding:12px;margin:6px 0 12px">
                  <div style="margin-bottom:6px"><strong>Folder number:</strong>
                    <span style="color:#059669;font-weight:800;font-size:15px">
                      ${p.id || '—'}</span></div>
                  <div><strong>Name:</strong> ${p.name || '—'}</div>
                  <div><strong>Membership no:</strong> ${p.membershipNo || '—'}</div>
                </div>
                Search for <b>${p.id || 'that folder number'}</b>, open the patient
                and save — that reactivates them for today without a second
                folder number.
              </div>`,
            width: 560,
            confirmButtonColor: '#d97706',
          });
          return;
        }

        console.error('Error saving patient:', error);
        await Swal.fire({
          title: 'Error',
          text: data?.message || 'Failed to Save Patient Information',
          icon: 'error'
        });
      }
    }
  }
};

  // Your existing renderStepContent function remains exactly the same...
  const renderStepContent = (step) => {
    switch (step) {
      case 0: // Insurance Information
        return (
          <Fade in={true} timeout={600}>
            <Grid container spacing={4} columns={{ xs: 4, sm: 8, md: 12 }}>
              <Grid item xs={12} lg={8} size={12}>
                <Card>
                  <CardContent sx={{ p: 4 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                      <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#64748b', mr: 2 }} />
                      <Typography variant="h6" sx={{ color: '#64748b', fontWeight: 'bold' }}>
                        Insurance Information
                      </Typography>
                    </Box>
                    
                    <Grid container spacing={3} columns={{ xs: 4, sm: 8, md: 12 }}>
                      <Grid item xs={12} size={4}>
                        <FormControl fullWidth error={!!errors.cardType}>
                          <InputLabel required>Insurance</InputLabel>
                          <Select
                            value={formData.cardType}
                            onChange={handleInputChange('cardType')}
                            label="Card Type(s) *"
                          >
                            {cardTypeOptions.map((type) => (
                              <MenuItem key={type.id} value={type.name}>{type.name}</MenuItem>
                            ))}
                          </Select>
                          {errors.cardType && (
                            <FormHelperText>{errors.cardType}</FormHelperText>
                          )}
                        </FormControl>
                      </Grid>
                     
                      <Grid item xs={8} size={3}>
                        <TextField
                          fullWidth
                          label="Membership Number"
                          required
                          error={!!errors.membershipNo}
                          helperText={errors.membershipNo}
                          value={formData.membershipNo}
                          onChange={handleInputChange('membershipNo')}
                          placeholder="Enter membership number"
                        />
                      </Grid>

                      <Grid item xs={4} size={2}>
                        <Box sx={{ 
                          display: 'flex', 
                          alignItems: 'center', 
                          height: '100%',
                          bgcolor: '#f8fafc',
                          px: 2,
                          border: '1px solid #e2e8f0'
                        }}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={formData.dependant}
                                onChange={handleCheckboxChange('dependant')}
                                sx={{ color: '#64748b' }}
                              />
                            }
                            label="Dependant"
                          />
                        </Box>
                      </Grid>

                      <Grid item xs={12} md={12} size={3}>
                        <FormControl fullWidth required error={!!errors.ccc}>
                          <InputLabel htmlFor="ccc-input" shrink={!!formData.ccc || undefined}>
                            CCC
                          </InputLabel>
                          <OutlinedInput
                            id="ccc-input"
                            type="text"
                            value={formData.ccc || ''}
                            onChange={handleInputChange('ccc')}
                            error={!!errors.ccc}
                            notched={!!formData.ccc}
                            placeholder="Enter or generate CCC"
                            endAdornment={
                              <InputAdornment position="end">
                                <IconButton onClick={handelopenCCC} edge="end" aria-label="open CCC">
                                  <AddTaskIcon color="primary" />
                                </IconButton>
                              </InputAdornment>
                            }
                            label="CCC"
                          />
                          {errors.ccc && (
                            <FormHelperText error>{errors.ccc}</FormHelperText>
                          )}
                        </FormControl>
                      </Grid>
                      
                      <Grid item xs={12} size={4}>
                        <TextField
                          fullWidth
                          label="Ghana Card Number"
                          error={!!errors.ghanaCardNo}
                          helperText={errors.ghanaCardNo}
                          value={formData.ghanaCardNo}
                          onChange={handleInputChange('ghanaCardNo')}
                          placeholder="Enter Ghana Card number"
                        />
                      </Grid>
                      
                      <Grid item xs={12} size={4}>
                        <FormControl fullWidth error={!!errors.policyOption}>
                          <InputLabel>Policy</InputLabel>
                          <Select
                            value={formData.policyOption}
                            onChange={handleInputChange('policyOption')}
                            label="Policy Option"
                          >
                            {policyOptions.map((option) => (
                              <MenuItem key={option.id} value={option.policy}>{option.policy}</MenuItem>
                            ))}
                          </Select>
                          {errors.policyOption && (
                            <FormHelperText>{errors.policyOption}</FormHelperText>
                          )}
                        </FormControl>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Fade>
        );

      case 1: // Basic Information
        return (
          <Fade in={true} timeout={600}>
            <Grid container spacing={4} columns={{ xs: 4, sm: 8, md: 12 }}>
              <Grid item xs={12} lg={8} size={9}>
                <Card>
                  <CardContent sx={{ p: 4 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                      <Box sx={{ width: 8, height: 8, bgcolor: '#64748b', mr: 2 }} />
                      <Typography variant="h6" sx={{ color: '#64748b', fontWeight: 'bold' }}>
                        Basic Information
                      </Typography>
                    </Box>
                    
                    <Grid container spacing={3} columns={{ xs: 4, sm: 8, md: 12 }}>
                      <Grid item xs={12} sm={6} size={4}>
                        <TextField
                          fullWidth
                          label="Patient ID"
                          disabled
                          error={!!errors.patientId}
                          helperText={errors.patientId}
                          value={formData.patientId}
                          onChange={handleInputChange('patientId')}
                          placeholder="Enter patient ID"
                        />
                      </Grid>
                      
                      <Grid item xs={12} sm={6} size={4}>
                        <TextField
                          fullWidth
                          label="Surname"
                          required
                          error={!!errors.surname}
                          helperText={errors.surname}
                          value={formData.surname}
                          onChange={handleInputChange('surname')}
                          placeholder="Enter surname"
                        />
                      </Grid>
                      
                      <Grid item xs={12} sm={6} size={4}>
                        <TextField
                          fullWidth
                          label="Other Name(s)"
                          required
                          error={!!errors.othername}
                          helperText={errors.othername}
                          value={formData.othername}
                          onChange={handleInputChange('othername')}
                          placeholder="Enter other names"
                        />
                      </Grid>

                      <Grid item xs={12} sm={6} size={4}>
                        <FormControl fullWidth error={!!errors.gender}>
                          <InputLabel required>Gender</InputLabel>
                          <Select
                            value={formData.gender}
                            onChange={handleInputChange('gender')}
                            label="Gender *"
                          >
                            <MenuItem value='MALE'>MALE</MenuItem>
                            <MenuItem value='FEMALE'>FEMALE</MenuItem>
                          </Select>
                          {errors.gender && (
                            <FormHelperText>{errors.gender}</FormHelperText>
                          )}
                        </FormControl>
                      </Grid>
                      
                      <Grid item xs={12} sm={6} size={4}>
                        <DatePicker
                          label="Date of Birth"
                          value={formData.dateOfBirth}
                          slotProps={{ 
                            textField: { 
                              fullWidth: true,
                              required: true,
                              error: !!errors.dateOfBirth,
                              helperText: errors.dateOfBirth
                            } 
                          }}
                          onChange={handleDateChange}
                        />
                      </Grid>
                      
                      <Grid item xs={12} size={4}>
                      <Autocomplete
                        freeSolo
                        options={stayAtOptions}
                        value={formData.stayAt}
                        onChange={(event, newValue) => {
                          if (errors.stayAt) {
                            setErrors(prev => ({ ...prev, stayAt: '' }));
                          }
                          setFormData(prevFormData => ({
                            ...prevFormData,
                            stayAt: newValue || ''
                          }));
                        }}
                        onInputChange={(event, newInputValue) => {
                          if (errors.stayAt) {
                            setErrors(prev => ({ ...prev, stayAt: '' }));
                          }
                          setFormData(prevFormData => ({
                            ...prevFormData,
                            stayAt: newInputValue || ''
                          }));
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            label="Stay At"
                            required
                            error={!!errors.stayAt}
                            helperText={errors.stayAt}
                            placeholder="Select or enter current address"
                          />
                        )}
                      />
                    </Grid>
                    </Grid>

                    <Divider sx={{ my: 2}} />
                    
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                      <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#676767', mr: 2 }} />
                      <Typography variant="h6" sx={{ color: '#676767', fontWeight: 'bold' }}>
                        Family Information
                      </Typography>
                    </Box>
                    
                    <Grid container spacing={3} columns={{ xs: 4, sm: 8, md: 12 }}>
                      <Grid item xs={12} sm={6} size={4}>
                        <FormControl fullWidth error={!!errors.maritalStatus}>
                          <InputLabel required>Marital Status</InputLabel>
                          <Select
                            value={formData.maritalStatus}
                            onChange={handleInputChange('maritalStatus')}
                            label="Marital Status *"
                          >
                            {maritalStatusOptions.map((status) => (
                              <MenuItem key={status} value={status}>{status}</MenuItem>
                            ))}
                          </Select>
                          {errors.maritalStatus && (
                            <FormHelperText>{errors.maritalStatus}</FormHelperText>
                          )}
                        </FormControl>
                      </Grid>
                      
                      <Grid item xs={12} sm={6} size={4}>
                        <TextField
                          fullWidth
                          label="Spouse Name"
                          value={formData.spouseName}
                          onChange={handleInputChange('spouseName')}
                          disabled={formData.maritalStatus === 'single'}
                          placeholder="Enter spouse name"
                        />
                      </Grid>
                      
                      <Grid item xs={12} sm={6} size={4}>
                        <TextField
                          fullWidth
                          label="Number of Children"
                          value={formData.numberOfChildren}
                          onChange={handleInputChange('numberOfChildren')}
                          type="number"
                          placeholder="0"
                        />
                      </Grid>
                    </Grid>

                    <Divider sx={{ my: 2 }} />
                    
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                      <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#64748b', mr: 2 }} />
                      <Typography variant="h6" sx={{ color: '#475569', fontWeight: 'bold' }}>
                        Other Information
                      </Typography>
                    </Box>
                    
                    <Grid container spacing={3} columns={{ xs: 4, sm: 8, md: 12 }}>
                      <Grid item xs={12} sm={6} size={4}>
                        <FormControl fullWidth>
                          <InputLabel>Educational Level</InputLabel>
                          <Select
                            value={formData.educationalLevel}
                            onChange={handleInputChange('educationalLevel')}
                            label="Educational Level"
                          >
                            {educationOptions.map((level) => (
                              <MenuItem key={level} value={level}>{level}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      
                      <Grid item xs={12} sm={6} size={4}>
                        <TextField
                          fullWidth
                          label="Occupation"
                          value={formData.occupation}
                          onChange={handleInputChange('occupation')}
                          placeholder="Enter occupation"
                        />
                      </Grid>
                      
                      <Grid item xs={12} sm={6} size={4}>
                        <FormControl fullWidth>
                          <InputLabel>Religion</InputLabel>
                          <Select
                            value={formData.religion}
                            onChange={handleInputChange('religion')}
                            label="Religion"
                          >
                            {religionOptions.map((religion) => (
                              <MenuItem key={religion} value={religion}>{religion}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>

              {/* Image Upload */}
              <Grid item xs={12} lg={4} size={3}>
                <Box sx={{ position: 'sticky', top: 32 }}>
                  <Card sx={{ 
                    background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
                    border: '1px solid #93c5fd'
                  }}>
                    <CardContent sx={{ textAlign: 'center', p: 4 }}>
                      <Typography variant="h6" sx={{ mb: 3, color: '#1e40af', fontWeight: 'bold' }}>
                        Patient Photo
                      </Typography>
                      
                      <Box sx={{ position: 'relative', display: 'inline-block', mb: 3 }}>
                        <Avatar
                          src={imagePreview}
                          sx={{ 
                            width: 160, 
                            height: 160, 
                            mx: 'auto',
                            border: '4px solid white',
                            boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
                            background: imagePreview ? 'none' : 'linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%)'
                          }}
                        >
                          {!imagePreview && <Person sx={{ fontSize: 48, color: '#64748b' }} />}
                        </Avatar>
                        
                        {imagePreview && (
                          <IconButton
                            onClick={() => {
                              setImagePreview(null);
                              setImagePath('');
                              setFormData(prev => ({ ...prev, imagePath: '' }));
                            }}
                            sx={{
                              position: 'absolute',
                              top: -8,
                              right: -8,
                              bgcolor: '#ef4444',
                              color: 'white',
                              width: 32,
                              height: 32,
                              '&:hover': { bgcolor: '#dc2626' }
                            }}
                          >
                            <Close sx={{ fontSize: 16 }} />
                          </IconButton>
                        )}
                      </Box>
                      
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <input
                          type="file"
                          accept="image/*"
                          onChange={handleImageUpload}
                          style={{ display: 'none' }}
                          ref={fileInputRef}
                        />
                        
                        <Button
                          variant="outlined"
                          startIcon={<Upload />}
                          onClick={() => fileInputRef.current?.click()}
                          sx={{
                            borderColor: '#10b981',
                            color: '#10b981',
                            '&:hover': { borderColor: '#059669', bgcolor: 'rgba(16, 185, 129, 0.04)' }
                          }}
                        >
                          Upload Photo
                        </Button>
                        
                        <Button
                          variant="contained"
                          startIcon={<PhotoCamera />}
                          onClick={openCamera}
                          sx={{
                            color: '#ffffff',
                            bgcolor: '#10b981',
                            '&:hover': { bgcolor: '#059669' },
                            boxShadow: '0 4px 14px 0 rgba(16, 185, 129, 0.4)'
                          }}
                        >
                          Take Photo
                        </Button>
                        
                       
                      </Box>
                    </CardContent>
                  </Card>
                </Box>
              </Grid>
            </Grid>
          </Fade>
        );

      case 2: // Contact & Other Info
        return (
          <Fade in={true} timeout={600}>
            <Grid container spacing={4} columns={{ xs: 4, sm: 8, md: 12 }}>
              <Grid item xs={12} lg={8} size={6}>
                <Card>
                  <CardContent sx={{ p: 4 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                      <Box sx={{ width: 8, height: 8, borderRadius: '50%', color: '#64748b', mr: 2 }} />
                      <Typography variant="h6" sx={{ color: '#64748b', fontWeight: 'bold' }}>
                        Contact Information
                      </Typography>
                    </Box>
                    
                    <Grid container spacing={3} columns={{ xs: 4, sm: 8, md: 12 }}>
                      <Grid item xs={12} size={4}>
                        <TextField
                          fullWidth
                          label="Box / GPS Address"
                          value={formData.boxNumber}
                          onChange={handleInputChange('boxNumber')}
                          placeholder="AK-039-5028"
                        />
                      </Grid>
                      
                      <Grid item xs={12} size={4}>
                        <TextField
                          fullWidth
                          label="Telephone Number"
                          required
                          error={!!errors.telNumber}
                          helperText={errors.telNumber}
                          value={formData.telNumber}
                          onChange={handleInputChange('telNumber')}
                          placeholder="+233 123 456 789"
                        />
                      </Grid>
                      
                      <Grid item xs={12} size={4}>
                        <TextField
                          fullWidth
                          label="Email Address"
                          type="email"
                          value={formData.emailAddress}
                          onChange={handleInputChange('emailAddress')}
                          placeholder="patient@example.com"
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} lg={4} size={6}>
                <Card>
                  <CardContent sx={{ p: 4 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                      <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#64748b', mr: 2 }} />
                      <Typography variant="h6" sx={{ color: '#64748b', fontWeight: 'bold' }}>
                        Accompanied By
                      </Typography>
                    </Box>
                    
                    <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
                      <Grid item xs={12} size={4}>
                        <TextField
                          fullWidth
                          label="Name"
                          value={formData.accompaniedByName}
                          onChange={handleInputChange('accompaniedByName')}
                          placeholder="Enter name"
                        />
                      </Grid>
                      
                      <Grid item xs={12} size={4}>
                        <TextField
                          fullWidth
                          label="Telephone Number"
                          value={formData.accompaniedByTel}
                          onChange={handleInputChange('accompaniedByTel')}
                          placeholder="+233 123 456 789"
                        />
                      </Grid>
                      
                      <Grid item xs={12} size={4}>
                        <FormControl fullWidth>
                          <InputLabel>Relation</InputLabel>
                          <Select
                            value={formData.relation}
                            onChange={handleInputChange('relation')}
                            label="Relation"
                          >
                            {relationOptions.map((relation) => (
                              <MenuItem key={relation} value={relation}>{relation}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Fade>
        );

      case 3: // Vitals
        return (
          <Fade in={true} timeout={600}>
            <Grid container spacing={3} columns={{ xs: 4, sm: 8, md: 12 }} justifyContent="center">
              <Grid item xs={12} md={10} lg={8} size={12}>
                <Card>
                  <CardContent sx={{ p: 4 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                      <Thermostat sx={{ color: '#dc2626', mr: 1 }} />
                      <Typography variant="h6" sx={{ color: '#0f172a', fontWeight: 'bold' }}>
                        Initial Vitals
                      </Typography>
                      <Chip
                        label="Temperature required"
                        size="small"
                        sx={{ ml: 2, bgcolor: '#fee2e2', color: '#991b1b', fontWeight: 600 }}
                      />
                    </Box>

                    <Grid container spacing={2.5} columns={{ xs: 4, sm: 8, md: 12 }}>
                      <Grid item xs={12} sm={4} md={6} size={6}>
                        <TextField
                          fullWidth
                          required
                          label="Temperature (°C)"
                          type="number"
                          inputProps={{ step: '0.1', min: 25, max: 45 }}
                          value={vitalsForm.temperature}
                          onChange={handleVitalChange('temperature')}
                          error={!!errors.vital_temperature}
                          helperText={errors.vital_temperature}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Thermostat sx={{ color: '#dc2626', fontSize: 20 }} />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>

                      <Grid item xs={12} sm={4} md={6} size={6}>
                        <TextField
                          fullWidth
                          label="Pulse (bpm)"
                          type="number"
                          value={vitalsForm.pulse}
                          onChange={handleVitalChange('pulse')}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Favorite sx={{ color: '#ec4899', fontSize: 20 }} />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>

                      <Grid item xs={12} sm={4} md={6} size={6}>
                        <TextField
                          fullWidth
                          label="Blood Pressure (mmHg)"
                          placeholder="e.g. 120/80"
                          value={vitalsForm.bloodPressure}
                          onChange={handleVitalChange('bloodPressure')}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <MonitorHeart sx={{ color: '#3b82f6', fontSize: 20 }} />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>

                      <Grid item xs={12} sm={4} md={6} size={6}>
                        <TextField
                          fullWidth
                          label="Respiration Rate (/min)"
                          type="number"
                          value={vitalsForm.respirationRate}
                          onChange={handleVitalChange('respirationRate')}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Air sx={{ color: '#0ea5e9', fontSize: 20 }} />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>

                      <Grid item xs={12} sm={4} md={6} size={6}>
                        <TextField
                          fullWidth
                          label="SpO₂ (%)"
                          type="number"
                          inputProps={{ min: 0, max: 100 }}
                          value={vitalsForm.spo2}
                          onChange={handleVitalChange('spo2')}
                        />
                      </Grid>
                    </Grid>

                    <Typography variant="caption" sx={{ display: 'block', mt: 2.5, color: '#64748b' }}>
                      A full set of vitals can be edited later from the Vitals tab.
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Fade>
        );

      default:
        return 'Unknown step';
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Box sx={{ 
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 50%, #cbd5e1 100%)'
        }}>
          <Container maxWidth="xl" sx={{ py: 2 }}>
            {/* Header */}
            <Paper elevation={0} sx={{ 
              p: 2, 
              mb: 4, 
              background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
              border: '1px solid #e2e8f0'
            }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
                <Box>
                  <Typography variant="h4" sx={{ color: '#1e293b', fontWeight: 'bold', mb: 1 }}>
                    Patient Information
                  </Typography>
                  <Typography variant="body1" sx={{ color: '#64748b' }}>
                    Registration with secure information management
                  </Typography>
                </Box>
                
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 5, flexWrap: 'wrap' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography sx={{ color: '#64748b' }}>Search</Typography>
                    <TextField size="small" sx={{ width: 200 }} placeholder="Search patients..." />
                    <IconButton sx={{ color: '#10b981' }}>
                      <Search />
                    </IconButton>
                  </Box>
                  
                  <Box sx={{ display: 'flex', gap: 2 }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={formData.duaInsurance}
                          onChange={handleCheckboxChange('duaInsurance')}
                          sx={{ color: '#10b981' }}
                        />
                      }
                      label="Dua Insurance"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={formData.activate}
                          onChange={handleCheckboxChange('activate')}
                          sx={{ color: '#10b981' }}
                        />
                      }
                      label="Activate"
                    />
                  </Box>
                </Box>
              </Box>
            </Paper>

            {/* Progress Bar */}
            {loading && (
              <Box sx={{ mb: 2 }}>
                <LinearProgress sx={{ 
                  height: 6, 
                  borderRadius: 3,
                  bgcolor: '#e2e8f0',
                  '& .MuiLinearProgress-bar': {
                    bgcolor: steps[activeStep].color
                  }
                }} />
              </Box>
            )}

            {/* Step Indicator */}
            <Box sx={{ mb: 4 }}>
              <Stepper activeStep={activeStep} alternativeLabel sx={{
                '& .MuiStepLabel-root .Mui-completed': { color: '#10b981' },
                '& .MuiStepLabel-root .Mui-active': { color: steps[activeStep].color },
              }}>
                {steps.map((step, index) => (
                  <Step key={step.label}>
                    <StepLabel icon={
                      <Box sx={{
                        width: 48,
                        height: 48,
                        borderRadius: 3,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        bgcolor: index === activeStep ? step.color : index < activeStep ? '#10b981' : '#e2e8f0',
                        color: index <= activeStep ? 'white' : '#64748b',
                        transition: 'all 0.3s ease',
                        transform: index === activeStep ? 'scale(1.1)' : 'scale(1)',
                        boxShadow: index === activeStep ? `0 4px 14px 0 ${step.color}40` : 'none'
                      }}>
                        {index < activeStep ? <CheckCircle /> : step.icon}
                      </Box>
                    }>
                      <Typography variant="subtitle1" sx={{ fontWeight: 600, mt: 1 }}>
                        {step.label}
                      </Typography>
                      <Typography variant="caption" sx={{ color: '#64748b' }}>
                        {step.description}
                      </Typography>
                    </StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Box>

            {/* Step Content */}
            <Box sx={{ mb: 4 }}>
              {renderStepContent(activeStep)}
            </Box>

            {/* Navigation */}
            <Paper elevation={0} sx={{ 
              p: 4, 
              borderRadius: 4,
              background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
              border: '1px solid #e2e8f0'
            }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Button
                  disabled={activeStep === 0}
                  onClick={handleBack}
                  startIcon={<NavigateBefore />}
                  variant="outlined"
                  sx={{ 
                    borderColor: '#e2e8f0',
                    color: '#64748b',
                    '&:hover': { borderColor: '#cbd5e1', bgcolor: '#f8fafc' }
                  }}
                >
                  Back
                </Button>

                <Box sx={{ display: 'flex', gap: 2 }}>
                  {activeStep === steps.length - 1 ? (
                    <>
                      <Button
                        onClick={handleSubmit}
                        variant="contained"
                        startIcon={<Save />}
                        disabled={loading}
                        sx={{ 
                          bgcolor: '#10b981',
                          color: '#FFF',
                          '&:hover': { bgcolor: '#059669' },
                          boxShadow: '0 4px 14px 0 rgba(16, 185, 129, 0.4)'
                        }}
                      >
                        Save Patient
                      </Button>
                      <Button
                        variant="contained"
                        startIcon={<CreditCard />}
                        sx={{ 
                          bgcolor: '#6366f1',
                          color: '#FFF',
                          '&:hover': { bgcolor: '#4f46e5' },
                          boxShadow: '0 4px 14px 0 rgba(99, 102, 241, 0.4)'
                        }}
                      >
                        Generate ID Card
                      </Button>
                      <Button
                        variant="contained"
                        startIcon={<Clear />}
                        onClick={handleReset}
                        sx={{ 
                          bgcolor: '#ef4444',
                          color: '#FFF',
                          '&:hover': { bgcolor: '#dc2626' },
                          boxShadow: '0 4px 14px 0 rgba(239, 68, 68, 0.4)'
                        }}
                      >
                        Clear Form
                      </Button>
                    </>
                  ) : (
                    <Button
                      onClick={handleNext}
                      endIcon={<NavigateNext />}
                      variant="contained"
                      disabled={loading}
                      sx={{ 
                        bgcolor: steps[activeStep].color,
                        '&:hover': { 
                          bgcolor: steps[activeStep].color,
                          color: '#FFF',
                          filter: 'brightness(0.9)'
                        },
                        boxShadow: `0 4px 14px 0 ${steps[activeStep].color}40`
                      }}
                    >
                      Next
                    </Button>
                  )}
                </Box>
              </Box>
            </Paper>

            {/* Camera Dialog */}
            <Dialog open={cameraOpen} onClose={closeCamera} maxWidth="sm" fullWidth PaperProps={{
              sx: { borderRadius: 4, overflow: 'hidden' }
            }}>
              <DialogTitle sx={{ 
                bgcolor: '#f8fafc', 
                borderBottom: '1px solid #e2e8f0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}>
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                  Take Patient Photo
                </Typography>
                <IconButton onClick={closeCamera} sx={{ color: '#64748b' }}>
                  <Close />
                </IconButton>
              </DialogTitle>
              <DialogContent sx={{ p: 3 }}>
                <Box sx={{ 
                  textAlign: 'center',
                  bgcolor: '#000',
                  borderRadius: 3,
                  overflow: 'hidden',
                  position: 'relative',
                  width: '100%',
                  height: 'auto',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}>
                  <video
                    ref={videoRef}
                    autoPlay
                    playsInline
                    muted
                    style={{ 
                      width: '100%', 
                      height: 'auto',
                      maxHeight: '400px',
                      objectFit: 'cover',
                      display: 'block'
                    }}
                  />
                  <canvas ref={canvasRef} style={{ display: 'none' }} />
                </Box>
              </DialogContent>
              <DialogActions sx={{ p: 3, bgcolor: '#f8fafc', gap: 2 }}>
                <Button onClick={closeCamera} variant="outlined" sx={{ borderColor: '#e2e8f0', color: '#64748b' }}>
                  Cancel
                </Button>
                <Button onClick={capturePhoto} variant="contained" startIcon={<CameraAlt />} sx={{ 
                  bgcolor: '#2563eb',
                  '&:hover': { bgcolor: '#1d4ed8' },
                  boxShadow: '0 4px 14px 0 rgba(37, 99, 235, 0.4)'
                }}>
                  Capture Photo
                </Button>
              </DialogActions>
            </Dialog>
          </Container>
        </Box>

        <Ccc
          open={openCCC}
          onClose={handelCloseCCC}
          memberNumber={selectedPatient ? selectedPatient.Insurance : ''}
          onSubmit={getCCCData}
        />

         <PatientVitals
          open={openPatient}
          onClose={handelClosePatient}
          info={vitalsInfo}
         // onSubmit={getCCCData}
        />

        <BedAssignmentDialog
          open={bedDialogOpen}
          onClose={() => setBedDialogOpen(false)}
          patient={bedDialogPatient}
          currentUser={erUserInfo?.name || ''}
          onAssigned={() => {
            setBedDialogPatient(null);
            Swal.fire({
              title: 'Bed Assigned',
              text: 'Patient is now on the ER InPatient list.',
              icon: 'success',
              confirmButtonColor: '#1A9B7F',
            });
            if (typeof onPatientSaved === 'function') onPatientSaved();
          }}
        />
      </LocalizationProvider>
    </ThemeProvider>
  );
};


export default PatientInformation;